<template>
    <div class="Myboard">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>내 게시물 보기</h2>
            <div class="btn_back">
                <a @click="slidePanelClose">
                    <img src="@/assets/images/btn_back.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel"
             v-infinite-scroll="getArticleMeList"
             infinite-scroll-disabled="loading"
             infinite-scroll-distance="300"
        >
            <h2 class="slidePanel-title clearfix">
                <div class="tab-menu pull-left width-85">
                    <ul>
                        <li :class="myboardTab == 'board' ? 'active' : ''">
                            <a @click="myboardTab='board'">내 게시글</a>
                        </li>
                        <li :class="myboardTab == 'reply' ? 'active' : ''">
                            <a @click="myboardTab='reply'">내 댓글</a>
                        </li>
                    </ul>
                </div>
            </h2>
            <div class="boardList mrg-top-20">
                <ul>
                    <li v-for="(data, index) in list" :key="index">
                        <div class="infoBox" @click="boardDetailMove(data.nMenuNum, data.nBoardNum, data.oAuthorizeAccessRead)">
                            <h3>
                                <a>{{ data.strTitle }}</a>
                            </h3>
                            <div class="info">
                                <span class="time"> {{ data.strRegDate }}</span>
                            </div>
                        </div>
                        <div class="replyBox" v-if="myboardTab == 'board'">
                            <strong>{{ data.nReplyCnt }}</strong><span>댓글</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>

export default {
    name: 'Myboard',
    data() {
        return {
            myboardTab:'board',     // 선택된 Tab
            list:[],                // 게시글, 댓글 리스트
            page:1,                 // 페이지
            totalPage:1,            // 전체페이지
            loading:false,          // 로딩여부
            listMore:true,          // 추가 페이지 여부
        }
    },
    // 감시자
    watch: {
        // tab 변경
        myboardTab(){
            this.page = 1;
            this.list=[];
            this.loading=false;
            this.listMore=true;
            this.getArticleMeList();
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 게시글,댓글
        getArticleMeList(){
            if (this.listMore == false){
                return false;
            }

            this.loading = true;

            let param = {};
            this.ajaxGetAuth('/api/v1/article/me/'+this.myboardTab+'/'+this.page, param, this.getArticleMeListResult);
        },
        // 게시글,댓글 결과
        getArticleMeListResult(response){
            console.log(1)
            if (response.result.code == 0){
                // 검색결과가 없을 경우
                if (response.oArticle.setting.nArticleTotalCount == 0){
                    this.list = [];
                    this.page=1;
                    return false;
                }

                let vm = this;
                response.oArticle.list.forEach(function (key) {
                    vm.list.push(key)
                })

                // 현재 페이지와 마지막 페이지가 같은경우
                if(this.page == response.oArticle.setting.nMaxPage){
                    this.listMore = false;
                }
                this.page++;
                this.loading = false;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
    }
}
</script>

<style scoped>
    .gle-point{background: #f2f2f2;border-radius: 5px;flex: 1;display: flex;flex-direction: row;padding: 20px;}
    .gle-point h3{flex-basis: 100px;font-size: 15px;color: #000;line-height: 180%;}
    .gle-point h4{flex: 1;text-align: right;color: #0086ff;font-size: 18px;}
    .gle-expected {border-top: 1px solid #dfdfdf;border-bottom: 1px solid #dfdfdf;margin-top: 15px;padding: 20px 20px 20px 15px;}
    .gle-expected-point{flex: 1;display: flex;flex-direction: row;}
    .gle-expected-point h3{flex-basis: 100px;font-size: 15px;color: #000;line-height: 180%;}
    .gle-expected-point h4{flex: 1;text-align: right;color: #000;font-size: 18px;}
    .gle-expected p{color: #a4a4a4;}
    .form-box {font-size: 13px;}
    .form-box select {height: 40px;font-size: 13px;}

    .table-gle-point {font-size: 16px; color: #8d8d8d; font-weight: 600}
    .table-gle-result {font-size: 16px; color: #0086ff; font-weight: 600}
    .table-gle-contents {}
    .table-gle-contents h3{font-size: 13px; color: #000; font-weight: 600}
    .table-gle-contents h4{background: #00a0e9;font-size: 12px; color: #fff; font-weight: 300;display: inline-block; padding: 0 5px;margin: 2px 0;}
    .table-gle-contents h4.use{background: #7d7d7d}
    .table-gle-contents p{font-size: 13px; color: #a7a7a7; font-weight: 300}
</style>
